import React from "react";
import { motion } from "framer-motion";

const BackgroundImage = () => {
  return (
    <motion.div
      className="absolute inset-0 z-0 w-full h-full"
      style={{
        backgroundImage: "url('/background_logo.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        filter: "brightness(0.9) contrast(1.1) saturate(0.7)", // Filtro suave para overlay blanco
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Overlay blanco principal */}
      <div
        className="absolute inset-0 bg-white/60"
        style={{
          width: "100%",
          height: "100%",
          minHeight: "100%",
        }}
      />
    </motion.div>
  );
};

export default BackgroundImage;
